<script>
	export default {
		inserted: (el) => {
		/*
			Usage:
			<div v-tabs>

				<ul class="tabs__title">
					<li>A<li>
					<li>B<li>
					<li>C<li>
				</ul>

				<div class="tabs__content">A</div>
				<div class="tabs__content">B</div>
				<div class="tabs__content">C</div>

			</div>
		*/
			const tabControl = $(el).attr('aria-controls');
			const contentControl = $(el).attr('data-target');
			const toggle = $(el).attr('data-toggle');

			const link = $(el).find(tabControl);
			const content = $(el).find(contentControl);

			const setActive = (el) => {
				el.addClass(toggle)
					.siblings()
					.removeClass(toggle)
			}

			// set the first tab to active so the tabs initialize
			const first = $(tabControl).first();
			setActive(first);
			setActive(content.find(first.attr('target')));

			link.bind('click', function(){
				let target = $(this).attr('target')
				setActive( $(this) )
				setActive( content.find(target) )
			})

		}
	}
</script>



// WEBPACK FOOTER //
// resources/components/vue-directives/tabs.vue